module.exports = __webpack_public_path__ + "assets/img/timg (9).0171050a.png";